import { configureStore } from "@reduxjs/toolkit";
import uIReducer from "./uiSlice";

const store = configureStore({
  reducer: {
    ui: uIReducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: {
        //Ignore this to avoid complaints about non-seriazable data for the user Date type values
        ignoredActions: ["user/setUserData"],
        ignoredPaths: ["user.userData"],
      },
    });
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
